function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "medal");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Admin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "procurement/plan/details/contract-signing/contract-signed",
  transform: "translate(-1299.000000, -429.000000)",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(252.000000, 165.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4-Copy",
  transform: "translate(20.000000, 244.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "medal",
  transform: "translate(1028.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.461538, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "32.8280543 42.6421405 32.8280543 48.9130435 26.6063348 48.9130435 20.3846154 56.4381271 14.1628959 48.9130435 7.94117647 48.9130435 7.94117647 42.6421405 0.475113122 36.3712375 7.94117647 30.1003344 7.94117647 23.8294314 14.1628959 23.8294314 20.3846154 16.3043478 26.6063348 23.8294314 32.8280543 23.8294314 32.8280543 30.1003344 40.2941176 36.3712375"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "10.4298643 1.2541806 10.4298643 11.2876254 20.3846154 16.3043478 30.3393665 11.2876254 30.3393665 1.2541806"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.9638009,
  y1: 1.2541806,
  x2: 37.8054299,
  y2: 1.2541806,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 15.4072398,
  y1: 1.2541806,
  x2: 15.4072398,
  y2: 13.7959866,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 25.361991,
  y1: 1.2541806,
  x2: 25.361991,
  y2: 13.7959866,
  id: "Path"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "27.8506787 40.7608696 20.3846154 45.1505017 12.918552 40.7608696 12.918552 31.9816054 20.3846154 27.5919732 27.8506787 31.9816054"
})))))));

var SvgMedal = function SvgMedal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "57px",
    viewBox: "0 0 43 57",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medal.2256d35e.svg";
export { ForwardRef as ReactComponent };